<div class="documents-layout">
  
  <!-- Mobile: Toggle filters button -->
  <div class="lg:hidden fixed bottom-20 right-6 z-50">
    <button 
      mat-fab 
      color="primary" 
      (click)="toggleFilterPanel()"
      [matTooltip]="isFilterPanelOpen ? 'Ukryj filtry' : 'Pokaż filtry'">
      <mat-icon [svgIcon]="isFilterPanelOpen ? 'tabler_outline:x' : 'tabler_outline:filter'"></mat-icon>
    </button>
    
    <!-- Badge z liczbą aktywnych filtrów -->
    <span *ngIf="activeFiltersCount > 0 && !isFilterPanelOpen"
          class="absolute -top-1 -right-1 w-5 h-5 bg-orange-500 text-white text-xs rounded-full flex items-center justify-center font-medium">
      {{ activeFiltersCount }}
    </span>
  </div>

  <!-- Desktop: Clear filters FAB button -->
  <div *ngIf="activeFiltersCount > 0" class="hidden lg:block fixed bottom-20 right-6 z-50">
    <button 
      mat-fab 
      extended
      class="!bg-gradient-to-r !from-red-500 !to-rose-600 !text-white hover:!from-red-600 hover:!to-rose-700 shadow-xl"
      (click)="clearFiltersAndShowAll()"
      matTooltip="Wyczyść wszystkie filtry">
      <mat-icon [svgIcon]="'tabler_outline:filter-off'"></mat-icon>
      <span class="ml-2">Wyczyść filtry</span>
      <span class="ml-2 bg-white/20 px-2 py-0.5 rounded-full text-xs">{{ activeFiltersCount }}</span>
    </button>
  </div>

  <!-- Mobile overlay (backdrop) -->
  <div 
    *ngIf="isMobile && isFilterPanelOpen" 
    class="fixed inset-0 bg-black/50 z-40 lg:hidden"
    (click)="toggleFilterPanel()">
  </div>

  <!-- Panel filtrów (lewa strona) -->
  <aside 
    class="documents-layout__filters bg-white dark:bg-[#0d121e]"
    [class.documents-layout__filters--open]="isFilterPanelOpen"
    [class.documents-layout__filters--closed]="!isFilterPanelOpen">
    
    <div class="documents-layout__filters-content"  [class.z-50]="isMobile">
      <app-documents-filters-panel 
        [isMobile]="isMobile"
        (closePanel)="toggleFilterPanel()">
      </app-documents-filters-panel>
    </div>
  </aside>
  
  <!-- Główna zawartość -->
  <main class="documents-layout__main">
    
    <!-- Header - zawsze widoczny -->
    <header class="documents-layout__header">
      <div class="flex items-center justify-between gap-4">
        
        <div class="flex items-center gap-3">
          <!-- Toggle panel button (desktop) -->
          <button 
            mat-icon-button 
            class="hidden lg:flex"
            (click)="toggleFilterPanel()"
            [matTooltip]="isFilterPanelOpen ? 'Ukryj panel filtrów' : 'Pokaż panel filtrów'">
            <mat-icon [svgIcon]="isFilterPanelOpen ? 'tabler_outline:layout-sidebar-left-collapse' : 'tabler_outline:layout-sidebar-left-expand'"></mat-icon>
          </button>
          
          <div>
            <h1 class="text-xl lg:text-2xl font-semibold">Dokumenty</h1>
            <p class="text-sm text-gray-500 hidden sm:block">
              {{ total }} {{ total === 1 ? 'dokument' : total < 5 ? 'dokumenty' : 'dokumentów' }}
              <span *ngIf="enableKsefFeatures && stats.pendingKsef > 0" class="text-orange-500">
                · {{ stats.pendingKsef }} oczekuje na KSeF
              </span>
            </p>
          </div>
        </div>
        
        <div class="flex items-center gap-2">
          <!-- Download many button -->
          <button mat-button (click)="showPrintManyDialog()"
            matTooltip="Pobierz lub drukuj faktury z wybranego miesiąca">
            <mat-icon [svgIcon]="'tabler_outline:file-arrow-right'"></mat-icon>
            <span class="ml-2 hidden sm:inline">Pobierz wiele</span>
          </button>

          <!-- New document button -->
          <button mat-flat-button color="primary" routerLink="/konto/dokumenty/wystaw" data-tour-id="wystaw-dokument">
            <mat-icon [svgIcon]="'tabler_outline:plus'"></mat-icon>
            <span class="ml-2 hidden sm:inline">Wystaw dokument</span>
          </button>
        </div>
      </div>
    </header>
    
    <!-- Środkowa część - Loading / Empty / Table -->
    <div class="documents-layout__content">
      
      <!-- Loading state (tylko pierwsze ładowanie, gdy lista jest pusta) -->
      <div *ngIf="isLoading && documents.length === 0" class="flex items-center justify-center h-full">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
      
      <!-- Empty state -->
      <div *ngIf="!isLoading && documents.length === 0" class="flex flex-col items-center justify-center h-full px-4">
        <mat-icon 
          class="icon-size-16 text-gray-300 dark:text-gray-600" 
          [svgIcon]="'tabler_outline:file-off'">
        </mat-icon>
        
        <!-- Komunikat gdy są filtry lub lokalne dokumenty -->
        <ng-container *ngIf="hasActiveFilters || hasAnyLocalDocuments; else firstDocumentMessage">
          <p class="mt-4 text-lg text-gray-500">Nie znaleziono żadnych dokumentów spełniających kryteria</p>
          
          <!-- Przycisk czyszczenia filtrów -->
          <button 
            *ngIf="hasActiveFilters"
            mat-flat-button 
            color="primary" 
            class="mt-6"
            (click)="clearFiltersAndShowAll()">
            <mat-icon [svgIcon]="'tabler_outline:filter-off'" class="mr-2"></mat-icon>
            Wyczyść filtry i pokaż wszystkie
          </button>
        </ng-container>
        
        <!-- Komunikat gdy brak jakichkolwiek lokalnych dokumentów -->
        <ng-template #firstDocumentMessage>
          <p class="mt-4 text-lg text-gray-500">Brak dokumentów</p>
          <p *ngIf="!isPurchasesView" class="text-sm text-gray-400">Zacznij od wystawienia pierwszego dokumentu</p>
          <button *ngIf="!isPurchasesView" mat-stroked-button color="primary" class="mt-4" routerLink="/konto/dokumenty/wystaw">
            <mat-icon [svgIcon]="'tabler_outline:plus'"></mat-icon>
            <span class="ml-2">Wystaw pierwszy dokument</span>
          </button>
        </ng-template>
      </div>
      
      <!-- Documents table -->
      <div *ngIf="documents.length > 0" class="documents-layout__table-wrapper">
        
        <div class="documents-layout__table-card">
          
          <!-- Table header (desktop) -->
          <div class="documents-layout__table-header"
               [class.documents-grid]="!isDraftsView"
               [class.documents-grid-drafts]="isDraftsView">
            <div class="whitespace-nowrap">Dokument</div>
            <div class="whitespace-nowrap hidden sm:block">Kontrahent</div>
            <div 
              class="items-center gap-1 cursor-pointer hover:text-gray-700 dark:hover:text-gray-300 select-none whitespace-nowrap hidden lg:flex"
              (click)="toggleSort('date')">
              <span>Data wystawienia</span>
              <mat-icon 
                *ngIf="currentSort.field === 'date'"
                class="icon-size-3.5 flex-shrink-0" 
                [svgIcon]="currentSort.direction === 'asc' ? 'tabler_outline:chevron-up' : 'tabler_outline:chevron-down'">
              </mat-icon>
            </div>
            <div 
              class="items-center justify-end gap-1 cursor-pointer hover:text-gray-700 dark:hover:text-gray-300 select-none whitespace-nowrap hidden sm:flex"
              (click)="toggleSort('amount')">
              <span>Kwota</span>
              <mat-icon 
                *ngIf="currentSort.field === 'amount'"
                class="icon-size-3.5 flex-shrink-0" 
                [svgIcon]="currentSort.direction === 'asc' ? 'tabler_outline:chevron-up' : 'tabler_outline:chevron-down'">
              </mat-icon>
            </div>
            <div *ngIf="!isDraftsView" class="text-center whitespace-nowrap hidden sm:block">Płatność</div>
            <div *ngIf="!isDraftsView && enableKsefFeatures" class="text-center whitespace-nowrap hidden sm:block">KSeF</div>
            <div></div>
          </div>
          
          <!-- Document rows - scrollable area -->
          <div #documentsContainer class="documents-layout__table-body pb-20 lg:pb-24">
            <app-document-row 
              *ngFor="let doc of documents; trackBy: trackByDocumentId"
              [document]="doc"
              [isDraftsView]="isDraftsView"
              [enableKsefFeatures]="enableKsefFeatures"
              [class.document-row--new]="isHighlighted(doc._id)"
              (searchByNip)="onSearchByNip($event)"
              (markAsPaid)="onMarkAsPaid($event)"
              (markAsUnpaid)="onMarkAsUnpaid($event)"
              (markAsIssued)="onMarkAsIssued($event)"
              (downloadXml)="onDownloadXml($event)"
              (downloadPdf)="onDownloadPdf($event)"
              (downloadUpo)="onDownloadUpo($event)"
              (sendToKsef)="onSendToKsef($event)"
              (issueAndSendToKsef)="onIssueAndSendToKsef($event)"
              (createAdvanceInvoice)="onCreateAdvanceInvoice($event)"
              class="block">
            </app-document-row>
          </div>
          
        </div>
        
      </div>
    </div>
    
    <!-- Pagination -->
    <footer *ngIf="totalPages > 1" class="documents-layout__pagination">
      <div class="flex items-center justify-between">
        <span class="text-sm text-gray-500">
          Strona {{ currentPage }} z {{ totalPages }}
        </span>
        
        <div class="flex items-center gap-1">
          <button 
            mat-icon-button 
            [disabled]="currentPage === 1"
            (click)="onPageChange(1)"
            matTooltip="Pierwsza strona">
            <mat-icon [svgIcon]="'tabler_outline:chevrons-left'"></mat-icon>
          </button>
          
          <button 
            mat-icon-button 
            [disabled]="currentPage === 1"
            (click)="onPageChange(currentPage - 1)"
            matTooltip="Poprzednia strona">
            <mat-icon [svgIcon]="'tabler_outline:chevron-left'"></mat-icon>
          </button>
          
          <button 
            mat-icon-button 
            [disabled]="currentPage === totalPages"
            (click)="onPageChange(currentPage + 1)"
            matTooltip="Następna strona">
            <mat-icon [svgIcon]="'tabler_outline:chevron-right'"></mat-icon>
          </button>
          
          <button 
            mat-icon-button 
            [disabled]="currentPage === totalPages"
            (click)="onPageChange(totalPages)"
            matTooltip="Ostatnia strona">
            <mat-icon [svgIcon]="'tabler_outline:chevrons-right'"></mat-icon>
          </button>
        </div>
      </div>
    </footer>
    
  </main>
  
</div>
